import React, { useState } from 'react';
import { Menu, Avatar, Text, Button, Group, ActionIcon, Badge } from '@mantine/core';
import { IconUser, IconSettings, IconLogout, IconDashboard, IconHeart, IconChevronDown, IconHome } from '@tabler/icons-react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

const UserMenu = () => {
  const { user, logout, isAdmin } = useAuth();
  const [userMenuOpened, setUserMenuOpened] = useState(false);

  if (!user) {
    return null;
  }

  return (
    <Menu
      shadow="md"
      width={200}
      position="bottom-end"
      opened={userMenuOpened}
      onOpen={() => setUserMenuOpened(true)}
      onClose={() => setUserMenuOpened(false)}
    >
      <Menu.Target>
        <Button
          variant="subtle"
          leftSection={
            <Avatar size="sm" color="green">
              {user.firstName ? user.firstName.charAt(0).toUpperCase() : user.username.charAt(0).toUpperCase()}
            </Avatar>
          }
          rightSection={<IconChevronDown size={14} />}
          color="green"
        >
          <Group gap="xs">
            <Text size="sm" fw={500}>
              {user.firstName ? `${user.firstName} ${user.lastName}` : user.username}
            </Text>
            {isAdmin() && (
              <Badge size="xs" color="red" variant="filled">
                Admin
              </Badge>
            )}
          </Group>
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Account</Menu.Label>
        
        <Menu.Item
          component={Link}
          to="/account"
          leftSection={<IconUser size={14} />}
        >
          My Account
        </Menu.Item>
        
        <Menu.Item
          component={Link}
          to="/favorites"
          leftSection={<IconHeart size={14} />}
        >
          My Favorites
        </Menu.Item>
        
        <Menu.Item
          component={Link}
          to="/add-listing"
          leftSection={<IconHome size={14} />}
        >
          Add Listing
        </Menu.Item>
        
        {isAdmin() && (
          <Menu.Item
            component={Link}
            to="/admin"
            leftSection={<IconDashboard size={14} />}
            color="red"
          >
            Admin Panel
          </Menu.Item>
        )}
        
        <Menu.Divider />
        
        <Menu.Item
          component={Link}
          to="/settings"
          leftSection={<IconSettings size={14} />}
        >
          Settings
        </Menu.Item>
        
        <Menu.Item
          onClick={logout}
          leftSection={<IconLogout size={14} />}
          color="red"
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default UserMenu;
